import { Modal } from "react-bootstrap";
import "./Altert_Modal.css";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";

const Altert_Modal = ({
  show,
  onHide,
  successText,
  btnname,
  onConfirm
}) => {
  return (
    <Modal
      className="Altert_Modal"
      size="sm"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Body>

        <p className="success_text">{successText}</p>

        {btnname && (
          <div style={{ textAlign: "center", marginTop: "15px" }}>
            <Pink_Btn
              btnText={btnname}
              onClick={() => {
                if (onConfirm) onConfirm();
                if (onHide) onHide();
              }}
            />
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default Altert_Modal;